/**
 * Selector to get an application based on the id, which can be sent in in
 */
import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';

import getApplications from '/business/shared/state/selectors/applications/getApplicationsSelector';
import getApplicationIdSelector from './getApplicationIdSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector([getApplications, getApplicationIdSelector], (applications, applicationId) => {
  if (!applications || !applicationId) {
    return null;
  }

  return applications?.find((application) => application.id === applicationId) || null;
});
